<template>
	<div>
		<a-page-header
			style="border: 1px solid rgb(235, 237, 240);"
			class="mb-3"
			title="Trending"
			@back="() => $router.go(-1)"
		>
		</a-page-header>
		<div class="card">
			<div
				class="card-header card-header-flex flex-column "
				:class="[tab === 'trending' ? 'bg-custom1' : 'bg-danger']"
			>
				<!-- <div class="d-flex text-white font-size-36">
					Instagram
				</div> -->
				<br />
				<div class="d-flex justify-content-center">
					<div class="mt-3 font-size-36 text-white">
						<template v-if="tab === 'trending'">
							<a-icon type="rise" />
							{{ trending.length }}
						</template>
						<template v-else>
							<a-icon type="fall" />
							{{ untrending.length }}
						</template>
					</div>
				</div>
				<a-tabs
					defaultActiveKey="1"
					class="air-tabs air-tabs-bold mt-2"
					v-model="tab"
				>
					<a-tab-pane key="trending">
						<template slot="tab">
							<span class="text-white">Trending</span>
						</template>
					</a-tab-pane>

					<a-tab-pane key="untrending">
						<template slot="tab">
							<span class="text-white">Untrending</span>
						</template>
					</a-tab-pane>
				</a-tabs>
			</div>
			<div class="card-body p-0 top-week">
				<template v-if="tab === 'trending'">
					<a-table
						class="activity"
						:columns="columns"
						:data-source="trending"
						:row-key="record => 'trending_' + record.postId"
					>
						<div
							slot="filterDropdown"
							slot-scope="{
								setSelectedKeys,
								selectedKeys,
								confirm,
								clearFilters,
								column,
							}"
							style="padding: 8px"
						>
							<a-input
								v-ant-ref="c => (searchInput = c)"
								:placeholder="`Search`"
								:value="selectedKeys[0]"
								style="width: 188px; margin-bottom: 8px; display: block;"
								@change="
									e => setSelectedKeys(e.target.value ? [e.target.value] : [])
								"
								@pressEnter="
									() => handleSearch(selectedKeys, confirm, column.dataIndex)
								"
							/>
							<a-button
								type="primary"
								icon="search"
								size="small"
								style="width: 90px; margin-right: 8px"
								@click="
									() => handleSearch(selectedKeys, confirm, column.dataIndex)
								"
							>
								Search
							</a-button>
							<a-button
								size="small"
								style="width: 90px"
								@click="() => handleReset(clearFilters)"
							>
								Reset
							</a-button>
						</div>
						<a-icon
							slot="filterIcon"
							slot-scope="filtered"
							type="search"
							:style="{ color: filtered ? '#108ee9' : undefined }"
						/>

						<template slot="rank" slot-scope="text, record">
							{{ trending.indexOf(record) + 1 }}
						</template>
						<template slot="net" slot-scope="text, record">
							<img
								style="width:18px;"
								v-if="record.networkName === 'TikTok'"
								src="/resources/images/tiktok-logo.png"
							/>
							<img
								v-if="record.networkName === 'Instagram'"
								src="/resources/images/instagram-logo.png"
								style="width:18px;"
							/>
							<img
								v-if="record.networkName === 'Youtube'"
								src="/resources/images/youtube-logo.png"
								style="width:18px;"
							/>
						</template>
						<template slot="accountName" slot-scope="text, record">
							<a-dropdown :trigger="['click']">
								<a
									class="ant-dropdown-link text-nowrap text-blue"
									@click="e => e.preventDefault()"
								>
									{{ text }} <a-icon type="down" />
								</a>
								<a-menu slot="overlay" @click="clickMenu($event, record)">
									<a-menu-item key="quick">
										Quick View
									</a-menu-item>
									<a-menu-item key="post">
										Go to Post
									</a-menu-item>
									<a-menu-item key="account">
										Go to Account
									</a-menu-item>
								</a-menu>
							</a-dropdown>

							<span class="text-truncate"></span>
						</template>
						<template slot="group" slot-scope="text, record">
							{{ record.accountGroup }}
						</template>

						<a-tooltip slot="postAvgInteractionsTitle" title="AVG Interactions">
							AVG
						</a-tooltip>
						<template slot="postAvgInteractions" slot-scope="text">
							<span class="text-truncate text-nowrap">{{
								text.toLocaleString()
							}}</span>
						</template>

						<a-tooltip slot="postInteractionstTitle" title="Interactions">
							<a-icon type="swap" />
						</a-tooltip>
						<template slot="postInteractions" slot-scope="text">
							<span class="text-truncate ">{{ text.toLocaleString() }}</span>
						</template>

						<a-tooltip slot="postHashtagTitle" title="Hashtag">
							<a-icon type="number" />
						</a-tooltip>

						<template
							slot="postHashtag"
							slot-scope="text, record, index, column"
						>
							<span v-if="searchText && searchedColumn === column.dataIndex">
								<template
									class="text-truncate text-nowrap"
									v-for="(fragment, i) in text
										.toString()
										.split(
											new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'),
										)"
								>
									<mark
										v-if="fragment.toLowerCase() === searchText.toLowerCase()"
										:key="i"
										class="highlight text-wrap"
										>{{ fragment }}</mark
									>
									<template v-else>
										<span class="text-wrap" :key="i">
											{{ fragment }}
										</span>
									</template>
								</template>
							</span>
							<template v-else>
								<span
									style="
									display: inline-block;
									max-width: 300px;
									min-width: 50px;
									text-overflow: ellipsis;
									"
									class="text-truncate hover-wrap"
								>
									{{ text }}
								</span>
							</template>
						</template>

						<a-tooltip slot="postVideoTitle" title="Video">
							<a-icon type="video-camera" />
						</a-tooltip>
						<template slot="postIsVideo" slot-scope="text, record">
							<span v-if="record.postIsVideo"><a-icon type="check"/></span>
						</template>

						<a-tooltip slot="postMentionTitle" title="Mentions">
							@
						</a-tooltip>

						<template
							slot="postMention"
							slot-scope="text, record, index, column"
						>
							<span v-if="searchText && searchedColumn === column.dataIndex">
								<template
									v-for="(fragment, i) in text
										.toString()
										.split(
											new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'),
										)"
								>
									<mark
										v-if="fragment.toLowerCase() === searchText.toLowerCase()"
										:key="i"
										class="highlight text-wrap"
										>{{ fragment }}</mark
									>
									<template v-else>
										<span class="text-wrap" :key="i">
											{{ fragment }}
										</span>
									</template>
								</template>
							</span>
							<template v-else>
								<span
									style="
									display: inline-block;
									max-width: 300px;
									min-width: 50px;
									text-overflow: ellipsis;
									"
									class="text-truncate hover-wrap"
								>
									{{ text }}
								</span>
							</template>
						</template>
					</a-table>
				</template>
				<template v-else>
					<a-table
						class="activity"
						:columns="columns"
						:data-source="untrending"
						:row-key="record => 'untrending_' + record.postId"
					>
						<div
							slot="filterDropdown"
							slot-scope="{
								setSelectedKeys,
								selectedKeys,
								confirm,
								clearFilters,
								column,
							}"
							style="padding: 8px"
						>
							<a-input
								v-ant-ref="c => (searchInput = c)"
								:placeholder="`Search`"
								:value="selectedKeys[0]"
								style="width: 188px; margin-bottom: 8px; display: block;"
								@change="
									e => setSelectedKeys(e.target.value ? [e.target.value] : [])
								"
								@pressEnter="
									() => handleSearch(selectedKeys, confirm, column.dataIndex)
								"
							/>
							<a-button
								type="primary"
								icon="search"
								size="small"
								style="width: 90px; margin-right: 8px"
								@click="
									() => handleSearch(selectedKeys, confirm, column.dataIndex)
								"
							>
								Search
							</a-button>
							<a-button
								size="small"
								style="width: 90px"
								@click="() => handleReset(clearFilters)"
							>
								Reset
							</a-button>
						</div>
						<a-icon
							slot="filterIcon"
							slot-scope="filtered"
							type="search"
							:style="{ color: filtered ? '#108ee9' : undefined }"
						/>

						<template slot="rank" slot-scope="text, record">
							{{ untrending.indexOf(record) + 1 }}
						</template>

						<template slot="net" slot-scope="text, record">
							<img
								style="width:18px;"
								v-if="record.networkName === 'TikTok'"
								src="/resources/images/tiktok-logo.png"
							/>
							<img
								v-if="record.networkName === 'Instagram'"
								src="/resources/images/instagram-logo.png"
								style="width:18px;"
							/>
							<img
								v-if="record.networkName === 'Youtube'"
								src="/resources/images/youtube-logo.png"
								style="width:18px;"
							/>
						</template>
						<template slot="accountName" slot-scope="text, record">
							<a-dropdown :trigger="['click']">
								<a
									class="ant-dropdown-link text-nowrap"
									@click="e => e.preventDefault()"
								>
									{{ text }} <a-icon type="down" />
								</a>
								<a-menu slot="overlay" @click="clickMenu($event, record)">
									<a-menu-item key="quick">
										Quick View
									</a-menu-item>
									<a-menu-item key="post">
										Go to Post
									</a-menu-item>
									<a-menu-item key="account">
										Go to Account
									</a-menu-item>
								</a-menu>
							</a-dropdown>

							<span class="text-truncate"></span>
						</template>
						<template slot="group" slot-scope="text, record">
							{{ record.accountGroup }}
						</template>
						<a-tooltip slot="postAvgInteractionsTitle" title="AVG Interactions">
							AVG
						</a-tooltip>
						<template slot="postAvgInteractions" slot-scope="text">
							<span class="text-truncate">{{ text.toLocaleString() }}</span>
						</template>

						<a-tooltip slot="postInteractionstTitle" title="Interactions">
							<a-icon type="swap" />
						</a-tooltip>
						<template slot="postInteractions" slot-scope="text">
							<span class="text-truncate">{{ text.toLocaleString() }}</span>
						</template>

						<a-tooltip slot="postHashtagTitle" title="Hashtag">
							<a-icon type="number" />
						</a-tooltip>

						<template
							slot="postHashtag"
							slot-scope="text, record, index, column"
						>
							<span v-if="searchText && searchedColumn === column.dataIndex">
								<template
									v-for="(fragment, i) in text
										.toString()
										.split(
											new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'),
										)"
								>
									<mark
										v-if="fragment.toLowerCase() === searchText.toLowerCase()"
										:key="i"
										class="highlight text-wrap"
										>{{ fragment }}</mark
									>
									<template v-else>
										<span class="text-wrap" :key="i">
											{{ fragment }}
										</span>
									</template>
								</template>
							</span>
							<template v-else>
								<span
									style="
									display: inline-block;
									max-width: 300px;
									min-width: 50px;
									text-overflow: ellipsis;
									"
									class="text-truncate hover-wrap"
								>
									{{ text }}
								</span>
							</template>
						</template>

						<a-tooltip slot="postVideoTitle" title="Video">
							<a-icon type="video-camera" />
						</a-tooltip>
						<template slot="postIsVideo" slot-scope="text, record">
							<span v-if="record.postIsVideo"><a-icon type="check"/></span>
						</template>

						<a-tooltip slot="postMentionTitle" title="Mentions">
							@
						</a-tooltip>

						<template
							slot="postMention"
							slot-scope="text, record, index, column"
						>
							<span v-if="searchText && searchedColumn === column.dataIndex">
								<template
									v-for="(fragment, i) in text
										.toString()
										.split(
											new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'),
										)"
								>
									<mark
										v-if="fragment.toLowerCase() === searchText.toLowerCase()"
										:key="i"
										class="highlight text-wrap"
										>{{ fragment }}</mark
									>
									<template v-else>
										<span class="text-wrap" :key="i">
											{{ fragment }}
										</span>
									</template>
								</template>
							</span>
							<template v-else>
								<span
									style="
									display: inline-block;
									max-width: 300px;
									min-width: 50px;
									text-overflow: ellipsis;
									"
									class="text-truncate hover-wrap"
								>
									{{ text }}
								</span>
							</template>
						</template>
					</a-table>
				</template>
			</div>

			<a-modal
				title="Quick View"
				:visible="quickViewVisible"
				:footer="null"
				:width="500"
				@cancel="handleCancelQuick"
				:bodyStyle="{ padding: 0 }"
			>
				<div class="width-500">
					<Loading :loading="postLoading" />
					<div v-if="post !== null">
						<template v-if="!post.isVideo">
							<PostImage :src="post.image" style="width:100%;" />
						</template>
						<template v-else>
							<PostImage :src="post.image" style="width:100%;" />
						</template>
					</div>
					<div class="py-2 bg-gray-1 pl-3" v-if="post !== null">
						<div class="d-flex flex-wrap">
							<div class="d-flex flex-wrap font-size-16">
								<div class="mr-3 my-2 text-nowrap">
									<i class="fa fa-thumbs-o-up font-size-20 mr-1"></i>
									{{ post.likes }}
								</div>
								<div class="mr-3 my-2 text-nowrap">
									<i class="fa fa-eye font-size-20 mr-1"></i>
									{{ post.views }}
								</div>
							</div>
						</div>
					</div>
				</div>
			</a-modal>
		</div>
	</div>
</template>

<script>
import * as ACTIONS from '@/store/actions'
import { mapActions } from 'vuex'

// import PostVideo from '@/components/widgets/Video'
import PostImage from '@/components/widgets/Image'
import Loading from '@/components/widgets/loading'

import moment from 'moment'
export default {
	components: {
		// PostVideo,
		PostImage,
		Loading,
	},
	data: function() {
		return {
			hover: false,
			moment,
			tab: 'trending',

			columns: [
				{
					key: 'rank',
					title: '',
					align: 'center',
					width: 50,
					scopedSlots: { customRender: 'rank' },
				},
				{
					key: 'net',
					title: '',
					align: 'center',
					width: 50,
					scopedSlots: { customRender: 'net' },
				},
				{
					dataIndex: 'accountName',
					key: 'accountName',
					title: 'Account',
					scopedSlots: { customRender: 'accountName' },
				},
				{
					key: 'group',
					title: 'Group',
					align: 'center',
					scopedSlots: { customRender: 'group' },
				},
				{
					dataIndex: 'postInteractions',
					key: 'postInteractions',
					scopedSlots: {
						title: 'postInteractionstTitle',
						customRender: 'postInteractions',
					},
					sorter: (a, b) => {
						return a.postInteractions - b.postInteractions
					},
				},
				{
					dataIndex: 'postAvgInteractions',
					key: 'postAvgInteractions',
					scopedSlots: {
						title: 'postAvgInteractionsTitle',
						customRender: 'postAvgInteractions',
					},
					sorter: (a, b) => {
						return a.postAvgInteractions - b.postAvgInteractions
					},
				},
				{
					dataIndex: 'postHashtag',
					key: 'postHashtag',

					scopedSlots: {
						filterDropdown: 'filterDropdown',
						filterIcon: 'filterIcon',
						title: 'postHashtagTitle',
						customRender: 'postHashtag',
					},
					onFilter: (value, record) => {
						console.log(value)
						return record.postHashtag
							.toString()
							.toLowerCase()
							.includes(value.toLowerCase())
					},

					onFilterDropdownVisibleChange: visible => {
						if (visible) {
							setTimeout(() => {
								this.searchInput.focus()
							}, 0)
						}
					},
				},

				{
					dataIndex: 'postMention',
					key: 'postMention',
					scopedSlots: {
						title: 'postMentionTitle',
						customRender: 'postMention',
						filterDropdown: 'filterDropdown',
						filterIcon: 'filterIcon',
					},
					onFilter: (value, record) => {
						return record.postMention
							.toString()
							.toLowerCase()
							.includes(value.toLowerCase())
					},

					onFilterDropdownVisibleChange: visible => {
						if (visible) {
							setTimeout(() => {
								this.searchInput.focus()
							}, 0)
						}
					},
				},
				{
					dataIndex: 'postIsVideo',
					key: 'Video',
					align: 'center',
					width: 50,
					scopedSlots: { title: 'postVideoTitle', customRender: 'postIsVideo' },
				},
			],
			trending: [],
			trendingLoading: true,
			untrending: [],
			untrendingLoading: true,
			searchText: '',
			searchInput: null,
			searchedColumn: '',
			post: null,
			postLoading: true,
			quickViewVisible: false,
		}
	},

	created() {
		this.loadTrending({ order: ['postAvgInteractions DESC'] }).then(res => {
			this.trendingLoading = false
			this.trending = res
		})
		this.loadUntrending({ order: ['postAvgInteractions DESC'] }).then(res => {
			this.untrendingLoading = false
			this.untrending = res
		})
	},
	methods: {
		...mapActions({
			loadTrending: ACTIONS.ACTIVITY.TRENDING,
			loadUntrending: ACTIONS.ACTIVITY.UNTRENDING,
			loadPost: ACTIONS.POST.BY_ID,
		}),
		handleCancelQuick() {
			this.quickViewVisible = false
		},
		clickMenu(e, activity) {
			if (e.key === 'quick') {
				this.post = null
				this.postLoading = true
				this.quickViewVisible = true

				this.loadPost({ id: activity.postId })
					.then(res => {
						this.post = res
						this.postLoading = false
					})
					.catch(() => {
						this.quickViewVisible = false
						this.$notification.error('Whoops', 'Invalid Post')
					})
			} else if (e.key === 'post') {
				this.$router.push('/post/' + activity.postId)
			} else {
				this.$router.push('/account/' + activity.accountId + '/profiles/')
			}
		},
		handleSearch(selectedKeys, confirm, dataIndex) {
			confirm()
			this.searchText = selectedKeys[0]
			this.searchedColumn = dataIndex
		},

		handleReset(clearFilters) {
			clearFilters()
			this.searchText = ''
		},
	},
}
</script>

<style>
.activity .ant-pagination {
	margin-right: 20px !important;
}
.activity .ant-table-tbody tr td {
	padding-top: 5px !important;
	padding-bottom: 5px !important;
}
.postImage {
	max-width: 100%;
	max-height: 160px;
	margin: 0 auto;
}
.hover-wrap:hover {
	text-overflow: clip;
	white-space: normal;
	word-break: break-all;
}
</style>
